import { ReactElement } from 'react';
import { EnergyContainer } from './components/styles';
import { UpgradeModule } from '../components/UpgradeModule';
import { TrendsCard } from './components/TrendsCard';
import { EnergyEfficiencyCard } from './components/EnergyEfficiencyCard';
import { getRowCardOrders } from '../helpers/cards';

interface EnergyProps {
  hasEnergy: boolean;
  hasWater: boolean;
  loading: boolean;
}

export function Energy({
  hasEnergy,
  hasWater,
  loading,
}: Readonly<EnergyProps>): ReactElement {
  const orders = getRowCardOrders(hasWater);

  return (
    <EnergyContainer expanded={!hasWater}>
      {!hasEnergy && <UpgradeModule module="moreModules" />}
      <div>
        <TrendsCard
          hasEnergy={hasEnergy}
          loading={loading}
          order={orders.trends}
          expandedSplit={!hasWater && hasEnergy}
        />
        <EnergyEfficiencyCard
          loading={loading}
          order={orders.efficiency}
          expandedSplit={!hasWater && hasEnergy}
        />
      </div>
    </EnergyContainer>
  );
}
